import { render, staticRenderFns } from "./ReservationBill.vue?vue&type=template&id=1d0ccc37&scoped=true&"
import script from "./ReservationBill.vue?vue&type=script&lang=js&"
export * from "./ReservationBill.vue?vue&type=script&lang=js&"
import style0 from "./ReservationBill.vue?vue&type=style&index=0&id=1d0ccc37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ccc37",
  null
  
)

export default component.exports